import type { Edge } from 'react-native-safe-area-context';

/**
 * Web implementation - preserves the original behavior (no explicit `edges`
 * prop applied all edges). Safe-area insets are 0 on desktop browsers, so this
 * keeps the web layout unchanged.
 */
export function useTabScreenEdges(): Edge[] {
  return ['top', 'right', 'bottom', 'left'];
}
